import { unique } from 'lib/array/arrayUtils'

export default function getTourV2CountryCodesVisited(itinerary: Array<App.Tours.TourV2OfferItineraryItem>): Array<string> {
  return unique(itinerary
    .flatMap(item => item.locationsVisitedDetails)
    .map(location => location.countryCode),
  )
}
